import { useMemo } from 'react'
import { PermissionKeysEnum } from '@/constants/enum'
import { useSelectWorkspaceUserInfo } from './user'
import { useDispatch } from 'react-redux'
import user from '@/services/apis/user'
import { setUserDetailInfo } from '@/store/user'

export const useCanReceive = () => {
  const userInfo = useSelectWorkspaceUserInfo()
  return useMemo(
    () =>
      !!userInfo?.permissions?.find?.(
        permission => permission.permissionKey === PermissionKeysEnum.QUERY_RECEIVE_ADDRESS
      ),
    [userInfo?.permissions]
  )
}

export const useCanSend = () => {
  const userInfo = useSelectWorkspaceUserInfo()
  return useMemo(
    () =>
      userInfo?.permissions?.find?.(
        permission => permission.permissionKey === PermissionKeysEnum.CREATE_TRADE
      ),
    [userInfo?.permissions]
  )
}

export const useCanManageWallet = () => {
  const userInfo = useSelectWorkspaceUserInfo()
  return useMemo(
    () =>
      userInfo?.permissions?.find?.(
        permission => permission.permissionKey === PermissionKeysEnum.MANAGEMENT_VAULT_ASSETS
      ),
    [userInfo?.permissions]
  )
}

export const useCheckCanManageTradePolicy = () => {
  const dispatch = useDispatch()
  const checkCanManageTradePolicy = async () => {
    const res = await user.getWorkspaceMember()
    if (res.success) {
      dispatch(setUserDetailInfo(res.data))
      const per = res.data?.permissions?.find?.(
        permission => permission.permissionKey === PermissionKeysEnum.MANAGEMENT_VAULT_TRADE_POLICY
      )
      return !!per?.hold
    }
    return false
  }
  return checkCanManageTradePolicy
}

// 判断是否有相应的权限
export const useIsManagement = (permissionKey: PermissionKeysEnum) => {
  const userInfo = useSelectWorkspaceUserInfo()
  return useMemo(
    () =>
      userInfo?.permissions?.find(permission => {
        return permission.permissionKey === permissionKey
      }),
    [userInfo?.permissions]
  )
}
